import axios from 'axios'
import router from '../router'
import Client from '@/assets/scripts/client'
import BaseConfig from '@/config/base.js'
import SecretKey from '@/config/secret-key.js'

import { generateRandomString, getQueryParams } from '@/utils/common.js'
import { SignatureUtil } from '@/utils/sign.js'
import { Toast } from 'vant'

// 按包短名注册的 API 域名解析策略
const apiBaseHostStrategies = {
  kiko(appPackageName, app) {
    const iosPackages = app.iosPackages || []
    return iosPackages.includes(appPackageName) ? app.apiBaseURL.ios : app.apiBaseURL.android
  },
}

function resolveApiBaseHost(appPackageName) {
  const shortName = BaseConfig.packageNameMap[appPackageName]
  const app = shortName ? BaseConfig.apps[shortName] : null
  const apiBaseURL = app?.apiBaseURL

  if (!apiBaseURL) {
    return BaseConfig.apps.vava?.apiBaseURL || ''
  }

  // 有策略走策略处理
  const strategy = apiBaseHostStrategies[shortName]
  if (strategy) {
    return strategy(appPackageName, app)
  }

  // 无策略则直接使用apiBaseURL
  return apiBaseURL
}

const isRelease = BaseConfig.isRelease
const language = Client.getAppInfoLang()

const { version, channel, deviceType, appPackageName, deviceId, timeZone } = Client.getAppInfo()

const apiHost = resolveApiBaseHost(appPackageName)
const baseURL = `https://${apiHost}`
const service = axios.create({ baseURL, timeout: 30000 })
service.interceptors.request.use(
  (config) => {
    const { uid, token } = Client.getUserBaseInfo()

    const signObj = {
      timestamp: '',
      nonce: '',
      authorization: '',
    }

    try {
      let appSecret = appPackageName ? SecretKey.sg[appPackageName] : ''
      const apiPath = config.url.replace(/\?.*$/, '') || ''
      let businessParams = {}

      // 浏览器场景 没有appPackageName deviceId
      if (Client.env.isBrowser) {
        appSecret = isRelease ? SecretKey.sg['com.qumi.h5'] : SecretKey.sg['com.example.h5']
      }
      if (config.data) {
        businessParams = { ...config.data }
      }
      if (config.params) {
        businessParams = { ...config.params, ...businessParams }
      }
      const queryObj = getQueryParams(config.url)
      if (queryObj && Object.keys(queryObj).length) {
        businessParams = { ...queryObj, ...businessParams }
      }

      signObj.timestamp = Date.now()
      signObj.nonce = generateRandomString(8)
      signObj.authorization = SignatureUtil.genSignature(
        appPackageName,
        deviceId,
        apiPath,
        signObj.timestamp,
        signObj.nonce,
        appSecret,
        businessParams
      )
    } catch (err) {
      console.log('try catch', err)
    }

    const headers = {
      channel: channel || '',
      version: version || '',
      // 0 安卓 1 IOS
      deviceType: deviceType || 0,
      appPackageName: appPackageName || '',
      deviceId: deviceId || '',
      language: language || '',
      timeZone: timeZone || '',
      uid: uid || '',
      token: token || '',
      platform: 'h5',
      ...signObj,
    }

    // 本地调试代码
    if (window.location.hostname === 'localhost') {
      headers.version = '4.2.7'
      headers.deviceType = deviceType || 0
      headers.appPackageName = appPackageName || 'com.example.gcc'
      headers.deviceId = deviceId || '9b7cdeac-9ea6-4467-b9c8-d94bdc690d4d'
      headers.language = language || 'en'
      headers.timestamp = ''
      headers.nonce = ''
      headers.authorization = ''
    }

    config.headers = headers

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// response
const noToastApi = ['/api/v2/app/withdraw/wallet/0/apply/check', '/api/v2/app/withdraw/wallet/1/apply/check', '/api/v2/app/shop/activity/27/cfg']
service.interceptors.response.use(
  (response) => {
    Toast.clear()

    const res = response.data

    if (res.status == 2013) {
      router.replace('/certification')
      return
    }

    // 异常status
    if (res.status !== 200) {
      if (res.error.status == 694) {
        return res.data || res
      }

      // 异常toast (具体根据接口地址判断)
      const errorUrl = ((response || {}).config || {}).url || ''
      if (!noToastApi.includes(errorUrl)) {
        Client.showToast(((res || {}).error || {}).description || 'Network Error')
      }

      return res.data || res
    }
    // 正常status
    else {
      return res.data || res
    }
  },
  (error) => {
    Client.showToast('Network Error')
    return Promise.reject(error)
  }
)

export default service
